export default {
      id: "website-usage",
      viewBox: "0 0 511.999 511.999",
      url: "../../assets/" + "sprite.svg#website-usage",
      toString: function () {
        return this.url;
      }
    }